var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_akar-circle-check",
    "data-name": "Icon akar-circle-check",
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.715,
    height: 86.715,
    viewBox: "0 0 86.715 86.715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M12,26.357,24.107,38.465,44.286,14.25",
    transform: "translate(15.215 19.018)",
    fill: "none",
    stroke: "#009517",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M83.715,43.358A40.358,40.358,0,1,1,43.358,3,40.358,40.358,0,0,1,83.715,43.358Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#009517",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4151eaeeb3afd8c8578b266092c12593.svg";
export { ForwardRef as ReactComponent };